module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview.6aef87b7.jpg";